import { useState } from "react";
import { v4 } from "uuid";

import { api, urls } from "@aprosoja/api";
import { useToastFeedbackUser } from "@aprosoja/stores";

import { useSignUpContext } from "@/app/screens/sign-up/context/sign-up.context";
import { AccountStepFormValues } from "./schema";

const useAccountStep = () => {
  const { setToast } = useToastFeedbackUser();
  const { signUpReducer, setSignUpReducer } = useSignUpContext();

  const onSubmit = async (values: AccountStepFormValues) => {
    try {
      const payload = {
        ...values,
        properties: signUpReducer?.calculationResults?.properties.map(
          (property) => ({
            ...property,
            city: property.city?.value,
            state: property.state.value,
          })
        ),
        role: "member",
        useTermsAccepted: true,
      };

      const response = signUpReducer?.createdUserData?.id
        ? await api.put(
            `${urls.users}/${signUpReducer?.createdUserData.id}`,
            values,
            {
              headers: {
                Authorization: `Bearer ${signUpReducer?.createdUserData?.access_token}`,
              },
            }
          )
        : await api.post(urls.users, payload);

      if (response.status === 200 || response.status === 201) {
        if (!signUpReducer?.createdUserData?.id) {
          setSignUpReducer({
            type: "createdUserData",
            createdUserDataPayload: {
              id: response.data.id,
              access_token: response.data.access_token,
            },
          });
        }
        setToast({
          id: v4(),
          title: `Associado ${signUpReducer?.createdUserData ? "editado" : "cadastrado"} com sucesso!`,
          status: "success",
        });
        setSignUpReducer({ type: "userAccount", userAccountPayload: values });
        setSignUpReducer({ type: "signUpStep", signUpStepPayload: 1 });
      }
    } catch (err: any) {
      if (err?.response?.data?.statusCode === 400) {
        setToast({
          id: v4(),
          title: err?.response?.data?.message,
          status: "error",
        });
      } else {
        setToast({
          id: v4(),
          title:
            "Algo deu errado, verifique as informações e tente novamente em instantes.",
          status: "error",
        });
      }
    }
  };

  return { onSubmit };
};

export default useAccountStep;
